import { domToPng, type Options as DomToPngOptions } from 'modern-screenshot';

export const SHARE_CARD_DOM_TO_PNG_OPTIONS: DomToPngOptions = {
    quality: 1,
    scale: 2,
    debug: false,
    onCloneNode: (node: Node) => {
        const el = node as HTMLElement;
        if (el.tagName === 'SCRIPT' || el.tagName === 'IFRAME' || el.tagName === 'NOSCRIPT') {
            el.remove();
        }
        if (el.classList?.contains('line-clamp-3') || el.classList?.contains('line-clamp-4')) {
            el.style.display = 'block';
            el.style.overflow = 'hidden';
            el.style.maxHeight = '6em';
        }
    },
};

export async function captureShareCardElement(element: HTMLElement): Promise<string> {
    await document.fonts.ready;
    await new Promise((resolve) => setTimeout(resolve, 500));
    return domToPng(element, SHARE_CARD_DOM_TO_PNG_OPTIONS);
}

export function dataUrlToBuffer(dataUrl: string): Buffer {
    const base64 = dataUrl.replace(/^data:image\/png;base64,/, '');
    return Buffer.from(base64, 'base64');
}

declare global {
    interface Window {
        __SHARE_CAPTURE_READY__?: boolean;
        __SHARE_CAPTURE_ERROR__?: string;
        __SHARE_CAPTURE_PNG__?: string;
    }
}

export async function runShareCardCapture(element: HTMLElement): Promise<void> {
    try {
        const dataUrl = await captureShareCardElement(element);
        window.__SHARE_CAPTURE_PNG__ = dataUrl.replace(/^data:image\/png;base64,/, '');
        window.__SHARE_CAPTURE_READY__ = true;
    } catch (error) {
        window.__SHARE_CAPTURE_ERROR__ = error instanceof Error ? error.message : 'capture_failed';
        window.__SHARE_CAPTURE_READY__ = false;
    }
}
